<ng-container *ngFor="let pair of inputWrapperPairs">
  <input
    #collapsedOverlay
    class="collapsed-input-wrapper input-wrapper input"
    [(ngModel)]="pair.value"
    (keypress)="isNumberKey($event, pair)"
    (blur)="parseInputValue($event, pair)"
  />
</ng-container>
<div
  #inputWrapper
  class="input-wrapper"
  [ngStyle]="{ top: bigCircle ? '0px' : '10px' }"
  *ngFor="let i of sliders"
>
  <span
    *ngIf="dragBar"
    class="drag-bar"
    [class.arrows]="arrows"
    [class.disabled]="disabled"
  ></span>
  <div
    *ngIf="arrows"
    class="left-arrow-wrapper"
    [class.disabled]="disabled"
    (click)="onArrowClick(i, -1)"
  >
    <div class="left-arrow"></div>
  </div>
  <div
    *ngIf="arrows"
    class="right-arrow-wrapper"
    [class.disabled]="disabled"
    (click)="onArrowClick(i, 1)"
  >
    <div class="right-arrow"></div>
  </div>
  <input
    type="text"
    class="input"
    [class.arrows]="arrows"
    maxlength="4"
    [disabled]="disabled"
    (keypress)="isNumberKey($event)"
    [(ngModel)]="inputsDisplayValue[i]"
    (blur)="parseInputValue($event)"
  />
  <div class="arrow-down"></div>
  <div class="circle" [class.big-circle]="bigCircle"></div>
</div>
<div #timeline class="timeline-wrapper">
  <ng-container *ngFor="let i of timelineHighlightsCount">
    <div
      #timelineHighlight
      *ngIf="sliders.length > 1"
      class="timeline-highlight"
      [class.disabled]="disabled"
      (click)="onTimelineClick($event)"
    ></div>
  </ng-container>
  <div
    class="timeline"
    [class.disabled]="disabled"
    (click)="onTimelineClick($event)"
  ></div>
  <div class="ticks-wrapper">
    <ng-container *ngFor="let t of ticks">
      <div
        #tickLabelWrapper
        class="tick-label-wrapper"
        *ngIf="t.label"
        [style.left]="t.position + 'px'"
      >
        <div
          [class.disabled-tick]="disabledYears?.includes(+t.label)"
          *ngIf="t.label"
          class="tick-label"
          (click)="clickTick(t)"
        >
          {{ t.label }}
        </div>
      </div>
      <div
        *ngIf="showTick(t.step)"
        class="tick"
        [style.left]="t.position + 'px'"
      ></div>
    </ng-container>
  </div>
</div>
